<form
  class="space-y-3"
  [formGroup]="form">
  <div class="bg-bg-surface-default space-y-5 rounded-xl p-8">
    <div class="pb-2">
      <h1 class="text-text-default text-lg font-bold">Tanggungan</h1>
      <p class="text-text-subtler text-sm">
        Informasi mengenai tanggungan yang dimiliki oleh karyawan
      </p>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <p class="text-text-default text-sm font-semibold">Status Kawin</p>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-radio
            class="block"
            mode="simple"
            [options]="marriageOption"
            formControlName="martial_status"
            (ngModelChange)="formService.resetError(formError, 'martial_status')" />
          @if (formError.martial_status.msg) {
            <p class="text-text-error text-xs">{{ formError.martial_status.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <p class="text-text-default text-sm font-semibold">Memiliki Tanggungan Anak?</p>
      <div class="col-span-2 space-y-2">
        <div class="space-y-1">
          <app-input-radio
            class="block"
            styleClass="!p-0 h-10 w-max !gap-0"
            dividerStyleClass="!p-0"
            radioBoxStyleClass="pl-2 pr-4"
            [options]="hasChildOption"
            formControlName="has_children"
            (ngModelChange)="_onHasChildrenChange($event)" />
          @if (formError.has_children.msg) {
            <p class="text-text-error text-xs">{{ formError.has_children.msg }}</p>
          }
        </div>
        @if (form.controls.children_count.hasValidator(Validators.required)) {
          <div class="space-y-1">
            <app-input-number
              class="block"
              formControlName="children_count"
              placeholder="Ketik Jumlah Anak"
              [useGrouping]="false"
              (ngModelChange)="formService.resetError(formError, 'children_count')">
              <div
                template="suffix"
                class="flex items-center p-2 pr-3">
                <p class="text-text-subtle text-xs font-semibold">Anak</p>
              </div>
            </app-input-number>
            @if (formError.children_count.msg) {
              <p class="text-text-error text-xs">{{ formError.children_count.msg }}</p>
            }
          </div>
        }
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <p class="text-text-default text-sm font-semibold">Tempat Tinggal Saat Ini</p>
      <div class="col-span-2 space-y-2">
        <div class="space-y-1">
          <app-input-radio
            class="block"
            styleClass="!p-0 h-10 !gap-0"
            dividerStyleClass="!p-0"
            radioBoxStyleClass="pl-2 pr-4"
            [options]="houseTypeOption"
            formControlName="living_status"
            (ngModelChange)="_onLivingStatusChange($event)" />
          @if (formError.living_status.msg) {
            <p class="text-text-error text-xs">{{ formError.living_status.msg }}</p>
          }
        </div>
        @if (form.controls.ownership_status.hasValidator(Validators.required)) {
          <div class="space-y-1">
            <app-input-radio
              class="block"
              styleClass="!p-0 h-10 !gap-0"
              dividerStyleClass="!p-0"
              radioBoxStyleClass="pl-2 pr-4"
              [options]="ownershipOption"
              formControlName="ownership_status"
              (ngModelChange)="formService.resetError(formError, 'ownership_status')" />
            @if (formError.ownership_status.msg) {
              <p class="text-text-error text-xs">{{ formError.ownership_status.msg }}</p>
            }
          </div>
        }
        <div class="space-y-1">
          <app-input-textarea
            class="block"
            formControlName="address_current"
            placeholder="Ketik Alamat Saat Ini"
            [rows]="5"
            (ngModelChange)="formService.resetError(formError, 'address_current')" />
          @if (formError.address_current.msg) {
            <p class="text-text-error text-xs">{{ formError.address_current.msg }}</p>
          }
        </div>
        @if (form.controls.rent_amount.hasValidator(Validators.required)) {
          <div class="space-y-1">
            <app-input-number
              class="block"
              formControlName="rent_amount"
              placeholder="Masukkan Harga Sewa"
              (ngModelChange)="formService.resetError(formError, 'rent_amount')">
              <div
                template="suffix"
                class="flex items-center p-2 pr-3">
                <p class="text-text-subtle text-xs font-semibold text-nowrap">Per Bulan</p>
              </div>
            </app-input-number>
            @if (formError.rent_amount.msg) {
              <p class="text-text-error text-xs">{{ formError.rent_amount.msg }}</p>
            }
          </div>
        }
      </div>
    </div>
  </div>
  <div class="flex items-center justify-between gap-3">
    <app-button
      theme="outline"
      class="block w-32"
      styleClass="bg-bg-surface-default"
      (click)="back.emit()">
      Kembali
    </app-button>
    <app-button
      class="ml-auto block w-32"
      (click)="_next()">
      Selanjutnya
    </app-button>
  </div>
</form>
